module.exports = __webpack_public_path__ + "img/3.a5dcf0e5.jpg";